// extracted by mini-css-extract-plugin
export default {"filled-button":"FilledSquareButton_filled-button__VxmqC"};